import React from "react";
import { useNavigate } from "react-router-dom";
import "./SubscriptionPage.css";

const SubscriptionPage = () => {
  const navigate = useNavigate();

  const plans = [
    {
      title: "Starter Plan",
      price: "10,000",
      description: "Best for startups and small businesses starting out.",
      features: [
        "Up to ₹1 Cr/month transaction volume",
        "40% UPI GTV minimum",
        "12 months discounted pricing",
      ],
      btnText: "subscription Now",
      color: "#4CAF50",
    },
    {
      title: "Growth Plan",
      price: "15,000",
      description: "Perfect for growing brands expanding their reach.",
      features: [
        "Higher transaction limits",
        "Priority support",
        "International card acceptance",
      ],
      btnText: "subscription Now",
      color: "#007bff",
    },
    {
      title: "Business Plan",
      price: "20,000",
      description: "Ideal for established companies with high volume.",
      features: [
        "Dedicated account manager",
        "Custom pricing available",
        "24/7 WhatsApp support",
      ],
      btnText: "subscription Now",
      color: "#FF9800",
    },
    {
      title: "Premium Plan",
      price: "25,000",
      description: "Designed for enterprises needing premium features.",
      features: [
        "Unlimited transaction volume",
        "Dedicated technical support",
        "Custom settlement cycle",
      ],
      btnText: "subscription Now",
      color: "#9C27B0",
    },
    // ================================
    {
      title: "Starter Plan",
      price: "100",
      description: "Basic communication APIs for small businesses.",
      features: [
        "SMS API",
        "Email API",
      ],
      btnText: "Subscribe Now",
      color: "#4CAF50",
    },
    {
      title: "Basic Plan",
      price: "150",
      description: "Essential APIs to start customer communication.",
      features: [
        "SMS API",
        "Email API",
        "OTP API",
      ],
      btnText: "Subscribe Now",
      color: "#66BB6A",
    },
    {
      title: "Basic Plus Plan",
      price: "200",
      description: "Multi-channel communication APIs.",
      features: [
        "SMS API",
        "Email API",
        "OTP API",
        "WhatsApp API",
      ],
      btnText: "Subscribe Now",
      color: "#2196F3",
    },
    {
      title: "Starter WhatsApp Plan",
      price: "250",
      description: "Start engaging customers on WhatsApp.",
      features: [
        "WhatsApp API",
        "SMS API",
        "Email API",
      ],
      btnText: "Subscribe Now",
      color: "#42A5F5",
    },
    {
      title: "Growth Plan",
      price: "300",
      description: "Growing businesses ke liye multiple APIs.",
      features: [
        "WhatsApp API",
        "SMS API",
        "Email API",
        "OTP API",
      ],
      btnText: "Subscribe Now",
      color: "#007bff",
    },
    {
      title: "Growth Plus Plan",
      price: "350",
      description: "Better reach with advanced APIs.",
      features: [
        "WhatsApp API",
        "SMS API",
        "Email API",
        "OTP API",
        "Webhook API",
      ],
      btnText: "Subscribe Now",
      color: "#1E88E5",
    },
    {
      title: "Business Plan",
      price: "400",
      description: "Professional communication APIs suite.",
      features: [
        "WhatsApp API",
        "SMS API",
        "Email API",
        "OTP API",
        "Voice Call API",
      ],
      btnText: "Subscribe Now",
      color: "#00ACC1",
    },
    {
      title: "Business Plus Plan",
      price: "450",
      description: "Advanced APIs with automation support.",
      features: [
        "WhatsApp API",
        "SMS API",
        "Email API",
        "OTP API",
        "Voice API",
        "Webhook API",
      ],
      btnText: "Subscribe Now",
      color: "#26C6DA",
    },
    {
      title: "Pro Plan",
      price: "500",
      description: "All essential APIs for large businesses.",
      features: [
        "WhatsApp API",
        "SMS API",
        "Email API",
        "OTP API",
        "Voice Call API",
        "Notification API",
      ],
      btnText: "Subscribe Now",
      color: "#FF9800",
    },
    {
      title: "Pro Plus Plan",
      price: "550",
      description: "High-level API access.",
      features: [
        "WhatsApp API",
        "SMS API",
        "Email API",
        "OTP API",
        "Voice API",
        "Webhook API",
        "Analytics API",
      ],
      btnText: "Subscribe Now",
      color: "#FB8C00",
    },
    {
      title: "Enterprise Plan",
      price: "600",
      description: "Enterprise-grade communication APIs.",
      features: [
        "WhatsApp API",
        "SMS API",
        "Email API",
        "OTP API",
        "Voice API",
        "Webhook API",
        "Analytics API",
        "CRM Integration API",
      ],
      btnText: "Subscribe Now",
      color: "#9C27B0",
    },
    {
      title: "Enterprise Plus Plan",
      price: "650",
      description: "Complete API ecosystem with premium support.",
      features: [
        "WhatsApp API",
        "SMS API",
        "Email API",
        "OTP API",
        "Voice API",
        "Webhook API",
        "Analytics API",
        "Custom Integration API",
      ],
      btnText: "Subscribe Now",
      color: "#6A1B9A",
    },

    // ================================
  ];

  const handleSubscribe = (plan) => {
    navigate("/subscribe", { state: plan });
  };

  return (
    <div className="pricing-page">
      <h1 className="main-heading">
        Lowest payment gateway charges in India
      </h1>
      <p className="sub-text">Choose the perfect plan for your business</p>

      <div className="plan-container">
        {plans.map((plan, index) => (
          <div key={index} className="plan-card">
            <h3>{plan.title}</h3>

            <p className="desc">{plan.description}</p>

            <ul>
              {plan.features.map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>

            <div className="plan-price">
              <span>₹{plan.price} / year</span>
              <button
                className="subscription-btn"
                style={{ backgroundColor: plan.color }}
                onClick={() => handleSubscribe(plan)}
              >
                {plan.btnText}
              </button>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionPage;